import { Loader2, Inbox } from "lucide-react";

export function LoadingState({ label = "Yükleniyor..." }) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 py-20 text-slate-500" data-testid="loading-state">
      <Loader2 className="h-8 w-8 animate-spin text-emerald-600" />
      <p className="text-sm">{label}</p>
    </div>
  );
}

export function EmptyState({ title = "Sonuç bulunamadı", description, icon: Icon = Inbox, action }) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 rounded-xl border border-dashed border-slate-200 bg-slate-50 py-16 text-center" data-testid="empty-state">
      <span className="flex h-14 w-14 items-center justify-center rounded-full bg-white text-slate-400 shadow-sm">
        <Icon className="h-7 w-7" />
      </span>
      <h3 className="font-display text-lg font-bold text-slate-800">{title}</h3>
      {description && <p className="max-w-sm text-sm text-slate-500">{description}</p>}
      {action}
    </div>
  );
}
